import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { fetchWrapper } from '../_helpers';

// create slice

const name = 'purchaseType';
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const purchaseTypeActions = { ...slice.actions, ...extraActions };
export const purchaseTypeReducer = slice.reducer;

// implementation

function createInitialState() {
    return {
        purchaseType: {}
    }
}

function createExtraActions() {
    const baseUrl = `${process.env.REACT_APP_API_URL}/user`;

    return {
        getAll: getAll()
    };    

    function getAll() {
        return createAsyncThunk(
            `${name}/getAll`,
            async () => await fetchWrapper.get(`${baseUrl}/GetPurchaseTypes`),
            { condition: (_, { getState }) => !Array.isArray(getState().purchaseType.purchaseType) }
        );
    }
}

function createExtraReducers() {
    return {
        ...getAll()
    };

    function getAll() {
        var { pending, fulfilled, rejected } = extraActions.getAll;
        return {
            [pending]: (state) => {
                state.purchaseType = { loading: true };
            },
            [fulfilled]: (state, action) => {
                state.purchaseType = action.payload;
            },
            [rejected]: (state, action) => {
                state.purchaseType = { error: action.error };
            }
        };
    }
}
